var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocAttach = function SvgDocAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9a1 1 0 1 0-2 0v2H5a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2H9V9Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h6a5 5 0 0 0 5-5V6.922a5 5 0 0 0-1.877-3.904L11.72 1.096A5 5 0 0 0 8.597 0H5ZM2 5a3 3 0 0 1 3-3h3.597A3 3 0 0 1 9 2.027V4a2 2 0 0 0 2 2h2.855a3 3 0 0 1 .145.923V15a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z",
    fill: "#242424"
  })));
};
export default SvgDocAttach;